module.exports = __webpack_public_path__ + "f556fd89429ad196aeda572835b52dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colour_diamond_ring@2x.png
// module id = 852
// module chunks = 0